import React from "react";
import Tel from "./Tel";

function Telephones(props) {
  const addTel = ph => {
    if (!ph) return undefined;
    const rx = /(\(([2-9][0-9][0-9])\) ([2-9][0-9][0-9])-([0-9][0-9][0-9][0-9]))/g;
    const ret = [];
    const now = ph.replace(rx, (a, b, c, d, e) => {
      ret.push([c, d, e]);
      return "|";
    });
    const arr = now.split("|");
    return (
      <React.Fragment>
        {arr.map((a, n) => (
          <React.Fragment key={n}>
            {arr[n]}
            <Tel num={ret[n]}></Tel>
          </React.Fragment>
        ))}{" "}
      </React.Fragment>
    );
  };
  
  return (
    <React.Fragment>{addTel(props.phonesString)}</React.Fragment>
  );
}
export default Telephones;
